import { AnalyticsAction, AnalyticsActionSubject } from '../../types';
import { BaseInvitePeopleAnalytics } from '../../analytics';
export class IntlProviderAnalytics extends BaseInvitePeopleAnalytics {
	translationMessageError(attributes: {
		error: {
			locale?: string;
			errorMessage: string;
		};
	}): void {
		this.fireOperational({
			action: AnalyticsAction.FAILED,
			actionSubject: AnalyticsActionSubject.TRANSLATION_MESSAGE,
			attributes: attributes,
		});
	}
}
